var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RequestControls"},[_c('CategoryMenuFilter',{attrs:{"filter-config":_vm.filterConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }